export default __webpack_public_path__ + "static/assets/133c58ac17103d7221dedca407c5a73f.jpg";